import {
  doc,
  setDoc,
  getDoc,
  updateDoc,
  arrayUnion,
  arrayRemove
} from 'firebase/firestore';

import { auth, db } from '../../firebase.config';



const normalizeVisitedItem = (item) => {
  if (item === null || item === undefined) {
    return {
      countryId: -1,
      status: null,
      visitedMonth: null,
      visitedYear: null,
      note: ''
    };
  }
  if (typeof item === 'number') {
    return {
      countryId: item,
      status: null,
      visitedMonth: null,
      visitedYear: null,
      note: ''
    };
  }
  if (typeof item === 'object' && item.countryId !== undefined) {
    return {
      countryId: item.countryId,
      status: item.status || null,
      visitedMonth: item.visitedMonth || null,
      visitedYear: item.visitedYear || null,
      note: item.note || ''
    };
  }
  return item;
};

export const saveVisitedlistToFirestore = async (userId, visitedlist) => {
  try {
    const userDocRef = doc(db, 'visitedlists', userId);
    const normalizedVisitedlist = visitedlist.map(normalizeVisitedItem);
    await setDoc(userDocRef, {
      visitedlist: normalizedVisitedlist,
      userName: auth.currentUser?.displayName || 'Traveler',
      lastUpdated: new Date()
    });

  } catch (err) {
    console.error('Error saving visited countries list:', err);
  }
};

export const loadVisitedlistFromFirestore = async (userId) => {
  try {
    const userDocRef = doc(db, 'visitedlists', userId);
    const docSnap = await getDoc(userDocRef);

    if (docSnap.exists()) {
      let visitedlist = docSnap.data().visitedlist || [];
      const needsMigration = visitedlist.length > 0 &&
      (
        typeof visitedlist[0] === 'number' ||
        visitedlist[0].visitedMonth === undefined ||
        visitedlist[0].visitedYear === undefined ||
        visitedlist[0].note === undefined
      );

    if (needsMigration) {
      visitedlist = visitedlist.map(normalizeVisitedItem);
        await setDoc(userDocRef,{
            visitedlist,
            userName: docSnap.data().userName || 'Traveler',
            lastUpdated: new Date()
        }, { merge: true });
      }
      return visitedlist;
    }
  } catch (err) {
    console.error('Error loading visited countries list:', err);
    return [];
  }
};

export const addCountryToVisitedlist = async (userId, countryCode) => {
  const userDocRef = doc(db, 'visitedlists', userId);

  const newItem = {
    countryId: countryCode,
    status: null,
    visitedMonth: null,
    visitedYear: null,
    note: ''
  };

  try {
    await updateDoc(userDocRef, {
      visitedlist: arrayUnion(newItem),
      userName: auth.currentUser?.displayName || 'Traveler',
      lastUpdated: new Date()
    });
  } catch (err) {
    if (err.code === 'not-found') {
      await setDoc(userDocRef, {
        visitedlist: [newItem],
        userName: auth.currentUser?.displayName || 'Traveler',
        lastUpdated: new Date()
      });
    } else {
      console.error('Error adding country to visited list:', err);
    }
  }
};

export const removeCountryFromVisitedlist = async (userId, countryCode) => {
  try {
    const userDocRef = doc(db, 'visitedlists', userId);
    const docSnap = await getDoc(userDocRef);

    if (docSnap.exists()) {
      const currentVisitedlist = docSnap.data().visitedlist || [];

      const itemToRemove = currentVisitedlist.find(e =>
        (typeof e === 'number' ? e : e.countryId) === countryCode
      );

      if (!itemToRemove) return

      if (itemToRemove) {
        await updateDoc(userDocRef, {
          visitedlist: arrayRemove(itemToRemove),
          userName: auth.currentUser?.displayName || 'Traveler',
          lastUpdated: new Date()
        });

      }
    }
  } catch (err) {
    console.error('Error removing country from visited list:', err);
  }
};

export const updateVisitedMetaInFirestore = async (userId, countryCode, updates) => {
  try {
    const userDocRef = doc(db, 'visitedlists', userId);
    const docSnap = await getDoc(userDocRef);

    if (docSnap.exists()) {
      const currentVisitedlist = docSnap.data().visitedlist || [];
      const updatedVisitedlist = currentVisitedlist.map(item => {
        const normalized = normalizeVisitedItem(item);
        if (normalized.countryId !== countryCode) {
          return normalized;
        }
        if (updates === null) {
          return {
            ...normalized,
            status: null,
            visitedMonth: null,
            visitedYear: null,
            note: ''
          };
        }
        
        return {
          ...normalized,
          ...updates,
          note: updates.note !== undefined
            ? updates.note.slice(0, 150)
            : normalized.note
        };
      });

      await setDoc(userDocRef, {
        visitedlist: updatedVisitedlist,
        userName: auth.currentUser?.displayName || 'Traveler',
        lastUpdated: new Date()
      }, { merge: true });
    }
  } catch (err) {
    console.error('Error updating visited status:', err);
  }
};